import Content from '../components/UpdateCredentialForm';
import {updateCredential} from "../actions";
import {connect} from "react-redux";
import {mapUpdateCredentialFormToProps} from "../selectors";

export default connect(mapUpdateCredentialFormToProps, {onSubmit: updateCredential})(Content);